$('.filter .__select select').each(function () {
    $(this).select2({
        dropdownCssClass: 'filter-dropdown',
        selectionCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
    })
});